import { ToGuidExpression, ToGuidExpressionType } from "../../../Models/ToGuidExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { MaybePromise } from "../../../Models/MaybePromise";

export class ToGuidExpressionEvaluator implements IExpressionEvaluator<ToGuidExpression>, IHasExpressionMetadata {
    get type(): string {
        return ToGuidExpressionType;
    }

    expressionProperties = ["Value"];

    evaluate(expression: ToGuidExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const result = context.Evaluator.evaluate(expression.Value, context);
        if (result instanceof Promise) {
            return result.then((v) => v == null ? v : String(v));
        }
        return result == null ? result : String(result);
    }
}
